import React from 'react';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormProps, getRequiredValidationRule, getValidationErrorProps } from 'util/Form';
import classNames from 'classnames';

import styles from './AdaptiveTextQuestionFormItem.module.scss';

const VALUE_MAX_LENGTH = 300;

interface AdaptiveTextQuestionFormItemProps extends FormProps {
  fieldName: string;
}

const AdaptiveTextQuestionFormItem: React.FunctionComponent<AdaptiveTextQuestionFormItemProps> = ({
  fieldName,
  required,
  disabled,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...getValidationErrorProps(error)}
          multiline
          required={required}
          disabled={disabled}
          inputProps={{ maxLength: VALUE_MAX_LENGTH }}
          FormHelperTextProps={{
            classes: {
              root: classNames({ [styles.helperText]: !error }),
            },
          }}
        />
      )}
      name={fieldName}
      control={control}
      rules={{
        required: getRequiredValidationRule('your answer', false, required),
      }}
    />
  );
};
export default AdaptiveTextQuestionFormItem;
